import { render, staticRenderFns } from "./ChartBaseBox.vue?vue&type=template&id=db8b1a32&"
import script from "./ChartBaseBox.vue?vue&type=script&lang=js&"
export * from "./ChartBaseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports